import { render, staticRenderFns } from "./BlockMainCurrency.vue?vue&type=template&id=0b817bcf&"
import script from "./BlockMainCurrency.vue?vue&type=script&lang=ts&"
export * from "./BlockMainCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports